// extracted by mini-css-extract-plugin
export default {"segment-form":"segment-form_yyE7t"};